// extracted by mini-css-extract-plugin
export default {"prizeImage":"styles_prizeImage__alPkc","video":"styles_video__wFmLW"};